import React, { useState,useEffect } from 'react'
import AppLayout from '../../layout/components/AppLayout'
import cmsServices from '../cmsServices';


const PageDetails = ({pageDetails}) =>{
  const [expend,setExpendStatus] = useState(false);
  return(
    <div className='card mb-2'>
      <div className={expend ? 'card-header bg-primary text-white' : 'card-header'} type="button" onClick={()=>{setExpendStatus(!expend)}}> {pageDetails.title}</div>
      {expend && <div className='card-body'>{pageDetails.details}</div>}
    </div>
  )
}


function AboutUsPage() {
  const [cmsPageList,setCmsPageList] = useState(null);

  const getCmsPages = () =>{
    cmsServices.getCmsPages().then(res=>{
      setCmsPageList(res.data);
    }).catch(error=>{

    })
  }

  useEffect(()=>{
    getCmsPages();
  },[])
  return (
    <AppLayout>
        <div className='container'>
          <div className='row'>
            {cmsPageList && cmsPageList.length >0 && cmsPageList.map(pageDetails=>
              <div key={pageDetails.id} className='col-md-12'>
                
                <PageDetails pageDetails={pageDetails} />
              </div>
            )}
            
          </div>
        </div>
    </AppLayout>
  )
}

export default AboutUsPage